/**
 * Utilitários para geolocalização
 * @module utils/geolocation
 */

const GEOLOCATION_OPTIONS = {
    enableHighAccuracy: true,
    timeout: 10000, // 10 segundos
    maximumAge: 60000 // Cache de 1 minuto
};

/**
 * Valida se as coordenadas são válidas
 * @param {number} latitude 
 * @param {number} longitude 
 * @returns {boolean}
 */
export const validateCoordinates = (latitude, longitude) => {
    if (typeof latitude !== 'number' || typeof longitude !== 'number') {
        return false;
    }
    return latitude >= -90 && latitude <= 90 && 
           longitude >= -180 && longitude <= 180;
};

/**
 * Captura a posição atual do dispositivo
 * @returns {Promise<{latitude: number, longitude: number}>}
 */
export const getCurrentPosition = () => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error('Geolocalização não suportada pelo navegador'));
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                
                if (!validateCoordinates(latitude, longitude)) {
                    reject(new Error('Coordenadas inválidas recebidas'));
                    return;
                }

                resolve({ latitude, longitude });
            },
            (error) => {
                let errorMessage = 'Erro ao obter localização';
                
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        errorMessage = 'Permissão de localização negada pelo usuário';
                        break;
                    case error.POSITION_UNAVAILABLE:
                        errorMessage = 'Localização indisponível';
                        break;
                    case error.TIMEOUT:
                        errorMessage = 'Tempo de espera excedido';
                        break;
                }
                
                reject(new Error(errorMessage));
            },
            GEOLOCATION_OPTIONS
        );
    });
};

/**
 * Formata coordenadas para exibição
 * @param {number} latitude 
 * @param {number} longitude 
 * @returns {string}
 */
export const formatCoordinates = (latitude, longitude) => {
    if (!latitude || !longitude) return 'N/A';
    return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
};

